var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"df":"","fdc":""}},[_c('span',{attrs:{"title":"","mb10":""}},[_vm._v(_vm._s(_vm.title))]),_c('span',{attrs:{"ml10":""}},[_vm._v(_vm._s(_vm._f("phoneFormat")(_vm.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }